module.exports = __webpack_public_path__ + "static/media/6_r_dver_90.26_27.96.77749357.png";